export function setModalAtts(modalElem, isHidden) {
    modalElem.setAttribute('data-is-active', isHidden ? false : true);
    modalElem.setAttribute('aria-hidden', isHidden);
}

export function hideModals(modals) {
    modals = modals instanceof NodeList ? modals : document.querySelectorAll('.modal');
    modals.forEach((modal) => setModalAtts(modal, true));
}

/**
 * Shows a modal.
 *
 * @param {string|HTMLElement} modal ID attribute of the modal or the modal element.
 * @param {NodeList} modalsToHide (Optional) The NodeList of modals to hide.
 */
export function showModal(modal, modalsToHide) {
    modal = modal instanceof HTMLElement ? modal : document.getElementById(modal);
    hideModals(modalsToHide);
    setModalAtts(modal, false);
}
